// Original hypothetical product scenarios, not historical ETF performance or product recommendations.
export const productsReview = {
  moduleId: 'products',
  title: '先讀清楚商品的承諾與限制',
  questions: [
    {
      id: 'products-constant-tracking-shortfall',
      lessonId: 'tracking-difference',
      question: '三個月中，每個月「基金月報酬減基準月報酬」都是 −0.10 個百分點。以這三筆差異的樣本標準差衡量追蹤誤差，且不做年化，哪個說法正確？',
      options: [
        '追蹤誤差為零，代表基金每月都完全沒有落後基準',
        '追蹤誤差為零，但每個月仍固定落後基準 0.10 個百分點',
        '追蹤誤差是 −0.10%，所以基金本身完全沒有市場風險',
      ],
      answer: 1,
      explanation: '三筆差異都等於它們的平均值，對平均值的偏離都是零，因此樣本標準差為零。追蹤誤差描述「差異有多不穩定」，不會消除固定落後；也不能由這個數字判斷基金本身的漲跌風險。三個月累計報酬差異則還需各期實際報酬計算。',
    },
    {
      id: 'products-coupon-current-yield',
      lessonId: 'bond-yields',
      question: '一張假想固定利率債券面額 1,000 元、票面利率 6%，每年付息 60 元。假設付息後以 900 元買入，忽略費用與稅，可以直接確認什麼？',
      options: [
        '票面利率是 6%、當期殖利率約 6.67%；到期殖利率仍要考慮年期及其他現金流',
        '到期殖利率必定是 6.67%，不需要知道剩幾年到期',
        '因為買價降到 900 元，契約每年利息也自動降為 54 元',
      ],
      answer: 0,
      explanation: '票面利率用 60 ÷ 1,000＝6%；當期殖利率用 60 ÷ 900≈6.67%。到期殖利率還包含各次利息、到期還本及時間，不能直接用當期殖利率取代。債券的實際收款仍有違約等風險，這些計算不是保證報酬。',
    },
    {
      id: 'products-daily-reset-path',
      lessonId: 'leveraged-etfs',
      question: '假想基準從 100 先漲 20% 到 120，再跌 16⅔% 回到 100。若另一資產每天都精準實現基準當日報酬的 2 倍，起始也是 100，忽略所有成本，兩天後約剩多少？',
      options: [
        '100，因為基準兩天的累計報酬是零',
        '106.67，因為第一天的上漲較大',
        '93.33，兩天累計約下跌 6.67%',
      ],
      answer: 2,
      explanation: '第一天為 100 × 1.4＝140；第二天基準精確下跌六分之一，2 倍資產下跌三分之一，因此 140 ×（1 − 1/3）＝93⅓。每天的倍數正確，跨日累計仍不等於基準累計的 2 倍。這是理想化路徑，真實槓桿 ETF 還有費用與追蹤差異。',
    },
    {
      id: 'products-bond-fund-horizon',
      lessonId: 'bond-fund-maturity',
      question: '假想甲 ETF 持續輪換持債，維持 7～10 年剩餘到期年期；乙 ETF 的文件則寫明以特定到期年度債券組成，預計 2030 年終止。哪個判斷較完整？',
      options: [
        '兩者都是債券 ETF，所以買進後十年一定按原始買價還本',
        '甲沒有因持有十年就自動還本；乙有預定終止安排，但也不代表保本',
        '所有債券 ETF 都不可能有預定終止年份，乙的文件一定錯誤',
      ],
      answer: 1,
      explanation: '一般持續運作的債券 ETF，組合中的債券到期不等於基金按你的買價還本。目標到期或固定期限產品則可能有預定終止安排，仍須讀其規則；最終分配會受持債違約、費用、現金管理等影響，不是固定本金保證。',
    },
  ],
};
